import styles from './index.module.css'

const TermsAndConditions = () => {
  return (
    <div className={styles.modal__fourth_section}>
      Available to approved applicants only and subject to completion of
      satisfactory credit check. Minimum monthly repayments are required. Paying
      only the minimum monthly repayment amount will generally not repay the
      purchase within the interest free period. A monthly account fee of $9.95
      will also apply and a one-off establishment fee may apply for new
      customers. Any balance outstanding at the expiry of the interest free
      period will be charged at the standard variable interest rate of 25.9% per
      annum as at 1 June 2023. Other charges may be payable, see T&Cs. Interest,
      fees and charges are subject to change. Terms & Conditions apply and are
      available on application. See your contract for further details. Credit
      provided by ZipMoney Payments Pty Ltd (ABN 58 164 440 993), Australian
      Credit Licence Number 441878). Minimum monthly repayments are required. A
      monthly account fee of $9.95 applies and is subject to change. Pay your
      closing balance in full by the due date each month and we’ll waive the
      fee. Available to approved applicants only and subject to completion of
      satisfactory credit check. Other charges may be payable. T&Cs apply.
    </div>
  )
}

export default TermsAndConditions
